import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Spacings } from '@styles/index';

const SocialImage = styled.div`
  width: ${Spacings.SPACING_6B};
  height: ${Spacings.SPACING_6B};
  border-radius: ${Spacings.SPACING_2B};
  transition: background-color 200ms ease;
  background-color: var(--color-base-1);
  border: 1px solid var(--color-divider);
  box-sizing: content-box;
  cursor: pointer;
  path {
    fill: ${({ $color }) => $color};
  }
  &:hover {
    background-color: ${({ $color }) => $color};
    path {
      fill: var(--color-base-1);
    }
  }
`;

const SocialIcon = ({ socialIcon, onClick }) => {
  const Icon = socialIcon.icon;
  return (
    <SocialImage $color={socialIcon.color} onClick={onClick}>
      <Icon />
    </SocialImage>
  );
};

SocialIcon.propTypes = {
  socialIcon: PropTypes.objectOf(PropTypes.any).isRequired,
  onClick: PropTypes.func.isRequired
};

export default SocialIcon;
